import { useEffect, useState } from 'react';

// project-imports
import ThemeCustomization from 'themes';

import Loader from 'components/Loader';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import FaviconUpdater from 'components/FaviconUpdater';
import NavigationBlocker from 'components/EnhancedNavigationBlocker';

import { dispatch } from 'store';
import { fetchMenu } from 'store/reducers/menu';

// auth-provider
import { ApiProvider as AuthProvider } from 'contexts/ApiContext';
import { FirebaseProvider } from 'contexts/FirebaseContext';
import { PersistentCallProvider } from 'contexts/PersistentCallContext';
import { VideoSessionProvider } from 'contexts/VideoSessionContext';
import { OutgoingCallProvider } from 'contexts/OutgoingCallContext';
import { ChatNotificationProvider } from 'contexts/ChatNotificationContext';
//client & team provider
import { SelectionProvider } from 'contexts/SelectionContext';
import { AnnouncementsProvider } from 'contexts/AnnouncementsContext';
import { ThemeConfigProvider } from 'contexts/ThemeConfigContext';
import { PermissionProvider } from 'contexts/PermissionContext';

import DynamicMsalProvider from 'components/DynamicMsalProvider';

import Routes from 'routes';
import { TranslationProvider } from 'contexts/TranslationProvider';
import { getInitialLanguage, LanguageContext, normalizeLanguage } from 'contexts/LanguageContext';

const App = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [language, setLanguage] = useState<string>(() => getInitialLanguage());

  useEffect(() => {
    dispatch(fetchMenu()).then(() => {
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!localStorage.getItem('appLang')) {
      localStorage.setItem('appLang', language);
    }
  }, [language]);

  const handleSetLanguage = (lang: string) => {
    const normalizedLanguage = normalizeLanguage(lang);
    localStorage.setItem('appLang', normalizedLanguage);
    setLanguage(normalizedLanguage);
  };

  if (loading) return <Loader />;
  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage }}>
      <TranslationProvider language={language}>
        <ThemeConfigProvider>
          <DynamicMsalProvider>
            <ThemeCustomization>
              <RTLLayout>
                <ScrollTop>
                  <AuthProvider>
                    <PermissionProvider>
                      <FirebaseProvider>
                        <OutgoingCallProvider>
                          <ChatNotificationProvider>
                            <VideoSessionProvider>
                              <PersistentCallProvider>
                                <SelectionProvider>
                                  <AnnouncementsProvider>
                                    <>
                                      <FaviconUpdater />
                                      <NavigationBlocker />
                                      <Notistack>
                                        <Routes />
                                        <Snackbar />
                                      </Notistack>
                                    </>
                                  </AnnouncementsProvider>
                                </SelectionProvider>
                              </PersistentCallProvider>
                            </VideoSessionProvider>
                          </ChatNotificationProvider>
                        </OutgoingCallProvider>
                      </FirebaseProvider>
                    </PermissionProvider>
                  </AuthProvider>
                </ScrollTop>
              </RTLLayout>
            </ThemeCustomization>
          </DynamicMsalProvider>
        </ThemeConfigProvider>
      </TranslationProvider>
    </LanguageContext.Provider>
  );
};

export default App;
